var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "token __pointer" },
    [
      _c("tx-pair-info", { attrs: { showDetail: _vm.showDetail } }),
      _vm._v(" "),
      _c("detail", { ref: "detailConfirm" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }